import { Component,Inject} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as levenshtein from 'fast-levenshtein';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-districtandtalukawise-office-representative',
  // standalone: true,
  // imports: [],
  templateUrl: './districtandtalukawise-office-representative.component.html',
  styleUrl: './districtandtalukawise-office-representative.component.scss'
})
export class DistrictandtalukawiseOfficeRepresentativeComponent {
  datewisedata;
    today = new Date();
    startdate = '';
    enddate = '';
    datewiselist = [];
    tempdata = [];
    district: any;
    taluka:any;
    
  
    isLoading: boolean = false;
    subTypesName = [
      { name: 'वार्षिक', isVisible: false },
      { name: 'त्रैवार्षिक', isVisible: false },
      { name: 'पंचवार्षिक', isVisible: false },
     
    ];
    totalth = 0;
    finalData = [];
    state: any;
    country: any;
    appliedFilters: any = {}; 
  
    constructor(
      private dialogref: MatDialogRef<DistrictandtalukawiseOfficeRepresentativeComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any
    ) { }
  
    ngOnInit(): void {
      debugger
      this.isLoading = true;
      this.district = this.data.district
         this.taluka = this.data.taluka
      this.datewisedata = this.data['data'];
      console.log(this.datewisedata, "first data")
      const officeRepresentativeMap = new Map<string, any>();
      
      console.log(this.datewisedata, "statewise")
      this.startdate = this.data['startDate'];
      this.enddate = this.data['endDate'];
      // console.log(formatDate(new Date(), 'MMMM', 'en-IN', 'GMT+0530'));

	this.appliedFilters = this.data['appliedFilters'] || {};

		console.log("Applied Filters:", this.appliedFilters);


      let data = this.uniqueData(this.datewisedata, (a) => a.subscription_type);
      officeRepresentativeMap.forEach((data) => {
  if (data.total_amt !== undefined) {
    data['एकूण'] = data.total_amt;
  }
});

  
      for (let i = 0; i < Object.keys(data).length; i++) {
        let flag = false;
        for (let j = 0; j < Object.keys(this.subTypesName).length; j++) {
          if (data[i]['subscription_type'] === this.subTypesName[j]['name']) {
            this.subTypesName[j]['isVisible'] = true;
            flag = true;
            break;
          }
        }
        if (!flag) {
          
          this.subTypesName.push({
            name: data[i]['subscription_type'],
            isVisible: true,
          });
          // }
        }
      }
  
      // console.log(this.subTypesName);
      // this.totalth = this.subTypesName.length * 3 + 3;
      this.totalth = this.subTypesName.filter(b => b.isVisible).length * 4 + 5;
      // this.getDateORrepwiselist();
      this.setData();
    }
  
    gettalukaTotal(talukaData: any[], key: string): number {
      return talukaData.reduce((sum, office) => sum + (office[key] || 0), 0);
    }
  
    gettalukaSubtypeTotal(talukaData: any[], subName: string, suffix: string): number {
      return talukaData.reduce((sum, office) => sum + (office.subtype_totals?.[this.getKey(subName) + suffix] || 0), 0);
    }
  
    getTotal(data: any[], key: string): number {
      return data.reduce((sum, country) =>
        sum + country.datewiseData.reduce((s, state) =>
          s + state.datewiseData.reduce((dSum, taluka) =>
            dSum + taluka.datewiseData.reduce((oSum, office) => oSum + (office[key] || 0), 0), 0), 0), 0);
    }
  
    getTotalSubtype(data: any[], subName: string, suffix: string): number {
      return data.reduce((sum, country) =>
        sum + country.datewiseData.reduce((s, state) =>
          s + state.datewiseData.reduce((dSum, taluka) =>
            dSum + taluka.datewiseData.reduce((oSum, office) =>
              oSum + (office.subtype_totals?.[this.getKey(subName) + suffix] || 0), 0), 0), 0), 0);
    }
  
    soundex(s: string): string {
      return s
        .toUpperCase()
        .replace(/[^A-Z]/g, "") // Remove non-alphabet characters
        .split("")
        .map((char) => {
          if ("AEIOUHWY".includes(char)) return "0";
          if ("BFPV".includes(char)) return "1";
          if ("CGJKQSXZ".includes(char)) return "2";
          if ("DT".includes(char)) return "3";
          if ("L".includes(char)) return "4";
          if ("MN".includes(char)) return "5";
          if ("R".includes(char)) return "6";
          return char;
        })
        .join("")
        .replace(/0/g, "");
    }
  
  

//Correct Method 

// setData() {
//   const countryMap = this.datewisedata.reduce((acc, record) => {
//     const { country, state, district_name, taluka } = record;
//     acc[country] ??= {};
//     acc[country][state] ??= {};
//     acc[country][state][district_name] ??= {};
//     acc[country][state][district_name][taluka] ??= [];
//     acc[country][state][district_name][taluka].push(record);
//     return acc;
//   }, {});

//   let finalTotal: any = {};
//   this.subTypesName.forEach((b: any, i) => {
//     if (b.isVisible) {
//       const name = this.getKey(b.name);
//       finalTotal[name + '_एकूण'] = 0;
//       finalTotal[name + '_नवीन'] = 0;
//       finalTotal[name + '_नूतनीकरण'] = 0;
//       if (i === 0) {
//         finalTotal['name'] = 'एकूण';
//         finalTotal['एकूण'] = 0;
//         finalTotal['नवीन'] = 0;
//         finalTotal['नूतनीकरण'] = 0;
//       }
//     }
//   });

//   Object.entries(countryMap).forEach(([country, states]: any) => {
//     Object.entries(states).forEach(([state, districts]: any) => {
//       Object.entries(districts).forEach(([district, talukas]: any) => {
//         Object.entries(talukas).forEach(([taluka, records]: any[]) => {

//           let totalData: any = {};
//           this.subTypesName.forEach((b: any, i) => {
//             if (b.isVisible) {
//               const name = this.getKey(b.name);
//               totalData[name + '_एकूण'] = 0;
//               totalData[name + '_नवीन'] = 0;
//               totalData[name + '_नूतनीकरण'] = 0;
//               if (i === 0) {
//                 totalData['एकूण'] = 0;
//                 totalData['नवीन'] = 0;
//                 totalData['नूतनीकरण'] = 0;
//               }
//             }
//           });

//            const officeRepresentativeMap = new Map<string, any>();
//           const representativeMap = new Map<string, any>();
//           const unknownReps = new Map<string, any>();

//           records.forEach((a: any) => {
//             const subKey = this.getKey(a.subscription_type);
//             const repKey = (a.rep_name || "Unknown").trim();
//             const officeKey = (a.office_rep_name || "Unknown").trim();
//             const amt = parseInt(a.total_amt);

//             if (!representativeMap.has(repKey)) {
//               representativeMap.set(repKey, {
//                 name: repKey,
//                 taluka: a.rep_taluka || '',
//                 total_amt: 0,
//                 new_count: 0,
//                 renew_count: 0
//               });
//               this.subTypesName.forEach((b: any, i) => {
//                 if (b.isVisible) {
//                   const name = this.getKey(b.name);
//                   const rep = representativeMap.get(repKey);
//                   rep[name + '_एकूण'] = 0;
//                   rep[name + '_नवीन'] = 0;
//                   rep[name + '_नूतनीकरण'] = 0;
//                   if (i === 0) {
//                     rep['एकूण'] = 0;
//                     rep['नवीन'] = 0;
//                     rep['नूतनीकरण'] = 0;
//                   }
//                 }
//               });
//             }

//             const rep = representativeMap.get(repKey);
//             rep.total_amt += amt;
//             rep.new_count += a.rcpt_type === 'New' ? 1 : 0;
//             rep.renew_count += a.rcpt_type === 'Renew' ? 1 : 0;
//             rep[subKey + '_एकूण'] += amt;
//             rep[subKey + '_नवीन'] += a.rcpt_type === 'New' ? 1 : 0;
//             rep[subKey + '_नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;
//             rep['एकूण'] += amt;
//             rep['नवीन'] += a.rcpt_type === 'New' ? 1 : 0;
//             rep['नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;

//             if (!officeRepresentativeMap.has(officeKey)) {
//               debugger
//               officeRepresentativeMap.set(officeKey, {
//                 total_amt: 0,
//                 new_count: 0,
//                 renew_count: 0,
//                 representatives: new Map<string, any>()
//               });
//               this.subTypesName.forEach((b: any, i) => {
//                 if (b.isVisible) {
//                   const name = this.getKey(b.name);
//                   const office = officeRepresentativeMap.get(officeKey);
//                   office[name + '_एकूण'] = 0;
//                   office[name + '_नवीन'] = 0;
//                   office[name + '_नूतनीकरण'] = 0;
//                   if (i === 0) {
//                     office['एकूण'] = 0;
//                     office['नवीन'] = 0;
//                     office['नूतनीकरण'] = 0;
//                   }
//                 }
//               });
//             }

//             const office = officeRepresentativeMap.get(officeKey);
//             office.total_amt += amt;
//             office.new_count += a.rcpt_type === 'New' ? 1 : 0;
//             office.renew_count += a.rcpt_type === 'Renew' ? 1 : 0;
//             office[subKey + '_एकूण'] += amt;
//             office[subKey + '_नवीन'] += a.rcpt_type === 'New' ? 1 : 0;
//             office[subKey + '_नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;
//             office['एकूण'] += amt;
//             office['नवीन'] += a.rcpt_type === 'New' ? 1 : 0;
//             office['नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;

//           if (!office.representatives.has(repKey)) {
//   office.representatives.set(repKey, { ...rep });
// } else {
//   const existing = office.representatives.get(repKey);
//   existing.total_amt += amt;
//   existing.new_count += a.rcpt_type === 'New' ? 1 : 0;
//   existing.renew_count += a.rcpt_type === 'Renew' ? 1 : 0;
//   existing[subKey + '_एकूण'] += amt;
//   existing[subKey + '_नवीन'] += a.rcpt_type === 'New' ? 1 : 0;
//   existing[subKey + '_नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;
//   existing['एकूण'] += amt;
//   existing['नवीन'] += a.rcpt_type === 'New' ? 1 : 0;
//   existing['नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;
// }


//             totalData[subKey + '_एकूण'] += amt;
//             totalData[subKey + '_नवीन'] += a.rcpt_type === 'New' ? 1 : 0;
//             totalData[subKey + '_नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;
//             totalData['एकूण'] += amt;
//             totalData['नवीन'] += a.rcpt_type === 'New' ? 1 : 0;
//             totalData['नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;

//             finalTotal[subKey + '_एकूण'] += amt;
//             finalTotal[subKey + '_नवीन'] += a.rcpt_type === 'New' ? 1 : 0;
//             finalTotal[subKey + '_नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;
//             finalTotal['एकूण'] += amt;
//             finalTotal['नवीन'] += a.rcpt_type === 'New' ? 1 : 0;
//             finalTotal['नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;
//           });

//           // 🔁 Add total_amt as एकूण for each office representative explicitly
//           officeRepresentativeMap.forEach((data) => {
//             if (data.total_amt !== undefined) {
//               data['एकूण'] = data.total_amt;
//             }
//           });

//           talukas[taluka] = {
//             records,
//             finalData: totalData,
//             representatives: Object.fromEntries(representativeMap),
//             officeRepresentatives: Object.fromEntries([...officeRepresentativeMap].map(([k, v]) => [k, { ...v, representatives: Object.fromEntries(v.representatives) }])),
//             unknownRepresentatives: Object.fromEntries(unknownReps)
//           };
//         });
//       });
//     });
//   });

//   const finalDataArray = Object.entries(countryMap).map(([key, value]) => ({ key, value }));
//   finalDataArray.push({ key: 'finalData', value: finalTotal });
//   this.finalData = finalDataArray;
//   this.isLoading = false;
// }

  
setData() {
  const countryMap: any = this.datewisedata.reduce((acc: any, record: any) => {
    const { country, state, district_name, taluka } = record;
    acc[country] ??= {};
    acc[country][state] ??= {};
    acc[country][state][district_name] ??= {};
    acc[country][state][district_name][taluka] ??= [];
    acc[country][state][district_name][taluka].push(record);
    return acc;
  }, {});

  // Initialize final overall total
  const finalTotal: any = {};
  this.subTypesName.forEach((b: any, i: number) => {
    if (b.isVisible) {
      const name = this.getKey(b.name);
      finalTotal[name + '_एकूण'] = 0;
      finalTotal[name + '_नवीन'] = 0;
      finalTotal[name + '_नूतनीकरण'] = 0;
      if (i === 0) {
        finalTotal['एकूण'] = 0;
        finalTotal['नवीन'] = 0;
        finalTotal['नूतनीकरण'] = 0;
      }
    }
  });

  // Iterate countries -> states -> districts
  Object.entries(countryMap).forEach(([country, states]: any) => {
    Object.entries(states).forEach(([state, districts]: any) => {
      Object.entries(districts).forEach(([district, talukas]: any) => {

        // Initialize district totals
        const districtTotal: any = {};
        this.subTypesName.forEach((b: any, i: number) => {
          if (b.isVisible) {
            const name = this.getKey(b.name);
            districtTotal[name + '_एकूण'] = 0;
            districtTotal[name + '_नवीन'] = 0;
            districtTotal[name + '_नूतनीकरण'] = 0;
            if (i === 0) {
              districtTotal['एकूण'] = 0;
              districtTotal['नवीन'] = 0;
              districtTotal['नूतनीकरण'] = 0;
            }
          }
        });

        // Iterate talukas (talukas is an object where keys are taluka names and values are arrays of records)
        Object.entries(talukas).forEach(([talukaName, recordsArr]: [string, any]) => {
          // skip if something unexpected, but normally recordsArr is array of records
          const records: any[] = Array.isArray(recordsArr) ? recordsArr : (recordsArr.records || []);

          const representativeMap = new Map<string, any>();
          const officeRepresentativeMap = new Map<string, any>();
          const unknownReps = new Map<string, any>();

          // Initialize taluka totals
          const talukaTotal: any = {};
          this.subTypesName.forEach((b: any, i: number) => {
            if (b.isVisible) {
              const name = this.getKey(b.name);
              talukaTotal[name + '_एकूण'] = 0;
              talukaTotal[name + '_नवीन'] = 0;
              talukaTotal[name + '_नूतनीकरण'] = 0;
              if (i === 0) {
                talukaTotal['एकूण'] = 0;
                talukaTotal['नवीन'] = 0;
                talukaTotal['नूतनीकरण'] = 0;
              }
            }
          });

          // Process each raw record in this taluka
          records.forEach((a: any) => {
            const subKey = this.getKey(a.subscription_type);
            const repKey = (a.rep_name || 'Unknown').trim();
            const officeKey = (a.office_rep_name || 'Unknown').trim();
            const amt = parseInt(a.total_amt || '0', 10) || 0;

            // Representative initialization if needed
            if (!representativeMap.has(repKey)) {
              const repObj: any = {
                name: repKey,
                taluka: a.rep_taluka || '',
                total_amt: 0,
                new_count: 0,
                renew_count: 0
              };
              // add subtype totals keys
              this.subTypesName.forEach((b: any, i: number) => {
                if (b.isVisible) {
                  const name = this.getKey(b.name);
                  repObj[name + '_एकूण'] = 0;
                  repObj[name + '_नवीन'] = 0;
                  repObj[name + '_नूतनीकरण'] = 0;
                  if (i === 0) {
                    repObj['एकूण'] = 0;
                    repObj['नवीन'] = 0;
                    repObj['नूतनीकरण'] = 0;
                  }
                }
              });
              representativeMap.set(repKey, repObj);
            }

            // update representative totals
            const rep = representativeMap.get(repKey);
            rep.total_amt += amt;
            rep.new_count += a.rcpt_type === 'New' ? 1 : 0;
            rep.renew_count += a.rcpt_type === 'Renew' ? 1 : 0;
            rep[subKey + '_एकूण'] += amt;
            rep[subKey + '_नवीन'] += a.rcpt_type === 'New' ? 1 : 0;
            rep[subKey + '_नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;
            rep['एकूण'] += amt;
            rep['नवीन'] += a.rcpt_type === 'New' ? 1 : 0;
            rep['नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;

            // Office representative initialization
            if (!officeRepresentativeMap.has(officeKey)) {
              const officeObj: any = {
                total_amt: 0,
                new_count: 0,
                renew_count: 0,
                representatives: new Map<string, any>()
              };
              // add subtype keys
              this.subTypesName.forEach((b: any, i: number) => {
                if (b.isVisible) {
                  const name = this.getKey(b.name);
                  officeObj[name + '_एकूण'] = 0;
                  officeObj[name + '_नवीन'] = 0;
                  officeObj[name + '_नूतनीकरण'] = 0;
                  if (i === 0) {
                    officeObj['एकूण'] = 0;
                    officeObj['नवीन'] = 0;
                    officeObj['नूतनीकरण'] = 0;
                  }
                }
              });
              officeRepresentativeMap.set(officeKey, officeObj);
            }

            const office = officeRepresentativeMap.get(officeKey);
            office.total_amt += amt;
            office.new_count += a.rcpt_type === 'New' ? 1 : 0;
            office.renew_count += a.rcpt_type === 'Renew' ? 1 : 0;
            office[subKey + '_एकूण'] += amt;
            office[subKey + '_नवीन'] += a.rcpt_type === 'New' ? 1 : 0;
            office[subKey + '_नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;
            office['एकूण'] += amt;
            office['नवीन'] += a.rcpt_type === 'New' ? 1 : 0;
            office['नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;

            // add representative to office.representatives map (or update)
            if (!office.representatives.has(repKey)) {
              // copy current rep snapshot
              office.representatives.set(repKey, { ...rep });
            } else {
              const existing = office.representatives.get(repKey);
              existing.total_amt += amt;
              existing.new_count += a.rcpt_type === 'New' ? 1 : 0;
              existing.renew_count += a.rcpt_type === 'Renew' ? 1 : 0;
              existing[subKey + '_एकूण'] += amt;
              existing[subKey + '_नवीन'] += a.rcpt_type === 'New' ? 1 : 0;
              existing[subKey + '_नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;
              existing['एकूण'] += amt;
              existing['नवीन'] += a.rcpt_type === 'New' ? 1 : 0;
              existing['नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;
            }

            // Totals: taluka, district, final
            talukaTotal[subKey + '_एकूण'] += amt;
            talukaTotal[subKey + '_नवीन'] += a.rcpt_type === 'New' ? 1 : 0;
            talukaTotal[subKey + '_नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;
            talukaTotal['एकूण'] += amt;
            talukaTotal['नवीन'] += a.rcpt_type === 'New' ? 1 : 0;
            talukaTotal['नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;

            districtTotal[subKey + '_एकूण'] += amt;
            districtTotal[subKey + '_नवीन'] += a.rcpt_type === 'New' ? 1 : 0;
            districtTotal[subKey + '_नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;
            districtTotal['एकूण'] += amt;
            districtTotal['नवीन'] += a.rcpt_type === 'New' ? 1 : 0;
            districtTotal['नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;

            finalTotal[subKey + '_एकूण'] += amt;
            finalTotal[subKey + '_नवीन'] += a.rcpt_type === 'New' ? 1 : 0;
            finalTotal[subKey + '_नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;
            finalTotal['एकूण'] += amt;
            finalTotal['नवीन'] += a.rcpt_type === 'New' ? 1 : 0;
            finalTotal['नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;
          }); // end records.forEach

          // convert officeRepresentativeMap.representatives maps -> objects
          const officeRepresentativesObject: any = Object.fromEntries(
            [...officeRepresentativeMap].map(([k, v]) => [
              k,
              { ...v, representatives: Object.fromEntries(v.representatives) }
            ])
          );

          // Save taluka block (replace the array with an object describing the taluka)
          talukas[talukaName] = {
            records,
            representatives: Object.fromEntries(representativeMap),
            officeRepresentatives: officeRepresentativesObject,
            finalData: talukaTotal
          };
        }); // end talukas loop

        // attach district total AFTER all talukas processed
        districts[district]['districtTotal'] = { ...districtTotal };
      });
    });
  });

  const finalDataArray = Object.entries(countryMap).map(([key, value]) => ({ key, value }));
  finalDataArray.push({ key: 'finalData', value: finalTotal });
  this.finalData = finalDataArray;
  this.isLoading = false;
}




  mergeRepresentativeData(target: any, source: any) {
    for (let key in source) {
      if (typeof source[key] === 'number') {
        target[key] = (target[key] || 0) + source[key];
      }
    }
  }
  
  
  
    getKey(name) {
      return name.replaceAll(' ', '_');
    }
  
    uniqueData(data, key) {
      return [...new Map(data.map((a) => [key(a), a])).values()];
    }
  
    exportExcel(fileName) {
      /* table id is passed over here */
      let element = document.getElementById('print-section1');
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
  
      /* generate workbook and add the worksheet */
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  
      /* save to file */
      XLSX.writeFile(wb, fileName + '.xlsx');
    }
  
  
    //Main Report Method Use in all Printing Page
  show = false

  // printPage() {
  //   this.show = true;
  //   const printContent = document.getElementById('print-section1')?.outerHTML;
  //   if (!printContent) {
  //     console.error("Print section not found!");
  //     return;
  //   }
  
  //   const printWindow = window.open('', '', 'width=1400,height=1000,top=50,left=50,scrollbars=yes');
  
  //   if (printWindow) {
  //     printWindow.document.open();
  //     printWindow.document.write(`
  //       <html>
  //         <head>
  //           <title>Print Report</title>
  //           <style>
  //             @media print {
  //               @page {
  //                 size: A3 landscape;
  //                 margin: 10mm;
  //               }
  
  //               body {
  //                 font-family: Arial, sans-serif;
  //                 font-size: 12px;
  //                 margin: 0;
  //                 padding: 0;
  //                 line-height: 1.4;
  //                 -webkit-print-color-adjust: exact;
  //                 print-color-adjust: exact;
  //               }
  
  //               table {
  //                 width: 100%;
  //                 border-collapse: collapse;
  //                 table-layout: fixed;
  //                 page-break-inside: avoid;
  //               }
  
  //               th, td {
  //                 padding: 1px;
  //                 border: 1px solid black;
  //                 text-align: center;
  //                 font-size: 12px;
  //                 line-height: 1.2;
  //                 word-break: break-word;
  //               }
  
  //               /* Make STATE column (left & right borders) lighter */
  //               td.state-col, th.state-col {
  //                 border-left: 1px solid #ccc !important;
  //                 border-right: 1px solid #ccc !important;
  //               }
  
  //               /* Make DISTRICT column (left border) lighter */
  //               td.district-col, th.district-col {
  //                 border-left: 1px solid #ccc !important;
  //               }
  
  //               /* Prevent line breaks in rep + taluka column */
  //               td.rep-taluka {
  //                 white-space: nowrap;
  //                 text-overflow: ellipsis;
  //                 max-width: 200px;
  //               }
  
  //               .noPrint {
  //                 display: none !important;
  //               }
  
  //               div, tr, td, th, tbody, thead, tfoot {
  //                 page-break-inside: avoid !important;
  //                 break-inside: avoid !important;
  //               }
  
  //               #print-section1 {
  //                 page-break-after: avoid;
  //                 break-after: avoid;
  //               }
  //             }
  //           </style>
  //         </head>
  //         <body>
  //           <div id="print-section1">
  //             ${printContent}
  //           </div>
  //           <script>
  //             window.onload = function() {
  //               window.print();
  //               setTimeout(() => { window.close(); }, 500);
  //             };
  //           </script>
  //         </body>
  //       </html>
  //     `);
  //     printWindow.document.close();
  //   } else {
  //     console.error("Failed to open print window.");
  //   }
  // }
  
  
    printPage() {
        this.show = true;
      
        const printContent = document.getElementById('print-section1')?.innerHTML;
        if (!printContent) {
          console.error("Print section not found!");
          return;
        }
      
        const printWindow = window.open('', '', 'width=1400,height=1000,top=50,left=50,scrollbars=yes');
      
        if (printWindow) {
          printWindow.document.open();
          printWindow.document.write(`
            <html>
              <head>
                <title>Print Report</title>
                <style>
                  @media print {
                    @page {
                      size: A3 landscape;
                      margin: 10mm;
                    }
      
                    body {
                      font-family: Arial, sans-serif;
                      font-size: 13px;
                      margin: 0;
                      padding: 0;
                    }
      
                    table {
                      width: 100%;
                      border-collapse: collapse;
                      page-break-inside: avoid;
                    }
      
                    th, td {
                      border: 1px solid black;
                      padding: 3px 5px;
                      font-size: 14px;
                      
                    }
      
                    tr {
                      page-break-inside: avoid;
                      page-break-after: auto;
                    }
      
                    .noPrint {
                      display: none;
                    }
                  }
      
                  body {
                    font-family: Arial, sans-serif;
                    font-size: 13px;
                  }
      
                  table {
                    width: 100%;
                    border-collapse: collapse;
                  }
      
                  th, td {
                    border: 1px solid black;
                    padding: 3px 5px;
                    text-align: center;
                  }
                </style>
              </head>
              <body>
                <div>
                  ${printContent}
                </div>
                <script>
                  window.onload = function() {
                    window.print();
                    setTimeout(() => { window.close(); }, 500);
                  };
                </script>
              </body>
            </html>
          `);
          printWindow.document.close();
        } else {
          console.error("Failed to open print window.");
        }
      }
  
  
  }
  